<template>
  Fant ikke siden
  <pre>{{ $route.params.path }}</pre>
</template>